enum Cookies {
  PWA_NEXT_ENABLED = 'pwa-next-enabled',
  USER_IDENTIFIER = 'ha_anonymous_id',
  FEATURES = 'ha-feature-flags',
  ADVERTISER_REVIEWS_ANSWER = 'ha-advertiser-reviews-answer',
  RENT_RADAR_ANSWER = 'ha-rent-radar-answer',
  ADVANCED_PRICING_BANNER_SHOWN = 'advanced-pricing-banner-shown',
  MESSAGES_TRANSLATE_LANGUAGE = 'messages-translate-language',
  MULTI_UNIT_BANNER_SHOWN = 'multi-unit-listing-banner-show',
  STUDENT_RESIDENCE_NOTICE_BANNER_SHOWN = 'student_residence_notice_banner_search',
}

export { Cookies };
